import { MasterDataDto, PetSizeDto, TimeLimitDto } from 'actions/masterData/MasterDataDtos';
import { FiltrableOption, Option, OrderedOption } from 'types/Generics';
import { MasterData } from 'types/MasterData';
import { TimeLimit } from 'types/OnlineBooking';
import { PetSize, PetTypeId, PetTypeIds } from 'types/Pet';

export const convertMasterData = (masterDataDto: MasterDataDto): MasterData => {
    return {
        petTypes: masterDataDto.pet_types,
        petAges: masterDataDto.pet_age,
        petGenders: masterDataDto.pet_gender,
        petBreeds: convertToBreeds(masterDataDto),
        petSizes: masterDataDto.pet_sizes.map(convertToPetSize),
        petHairColors: convertToPetHairColors(masterDataDto),

        relationships: masterDataDto.relationships,

        olbFromLimits: [...(masterDataDto.olb_minimum_lead_times || [])].map(limit =>
            convertToLimit(limit)
        ),
        olbToLimits: [...(masterDataDto.olb_maximum_lead_times || [])].map(limit =>
            convertToLimit(limit)
        ),

        paymentTypes: []
    };
};

const convertToBreeds = (dto: MasterDataDto) => {
    return Object.entries(dto.pet_breeds[0]).reduce<Array<FiltrableOption<number, PetTypeId>>>(
        (breeds, [petType, breedsDto]: [PetTypeId, Array<Option<number>>]) => {
            breedsDto.forEach(breed => {
                breeds.push({
                    id: breed.id,
                    filter: petType,
                    name: breed.name
                });
            });

            return breeds;
        },
        []
    );
};

const convertToPetSize = (dto: PetSizeDto): OrderedOption<PetSize> => ({
    order: dto.order,
    element: {
        id: dto.id,
        name: dto.name,
        description: dto.description,
        minWeight: dto.min_weight,
        maxWeight: dto.max_weight
    }
});

const convertToPetHairColors = (dto: MasterDataDto): Array<FiltrableOption<string, PetTypeId>> => {
    return dto.cat_hair_colors
        .map(hairColor => ({
            id: hairColor.id,
            name: hairColor.name,
            filter: PetTypeIds.CAT
        }))
        .concat(
            dto.dog_hair_colors.map(hairColor => ({
                id: hairColor.id,
                name: hairColor.name,
                filter: PetTypeIds.DOG
            }))
        )
        .concat(
            dto.exotic_hair_colors.map(hairColor => ({
                id: hairColor.id,
                name: hairColor.name,
                filter: PetTypeIds.EXOTIC
            }))
        );
};

const convertToLimit = (dto: TimeLimitDto): TimeLimit => ({
    id: dto.id,
    name: dto.name,
    offsetSeconds: dto.time
});
